// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"84ff1066","264":"9290f59d","480":"1f00bb7e","638":"07b85975","738":"1485d231"}[chunkId] + ".chunk.js";
};